export default __webpack_public_path__ + "static/media/single-project-page-05-img-06.4644bde8.jpg";